import { isStringLiteralOfType } from "@mcwd/typescript-type-guards";
import type { AnyFormFinalSetupObject } from "../../../../widgetDataTs.js";
import { getDocumentTitle, getVideoTitle } from "./getResourceTitle.js";
import { DocumentFormSettingsKey, VideoGatedFormSettingsKey, type AnyFormSettingsKey } from "../../../form-settings/form-experience/form-settings-keys.js";

export function getLastOfferName (formSettingsKey: AnyFormSettingsKey | undefined, widgetSetup: AnyFormFinalSetupObject): string | null
{
  if (formSettingsKey == null) {
    return null;
  }
  if (isStringLiteralOfType(formSettingsKey, [ ...DocumentFormSettingsKey, "video" ])) {
    return getDocumentTitle(widgetSetup);
  }
  if (isStringLiteralOfType(formSettingsKey, VideoGatedFormSettingsKey)) {
    return getVideoTitle(widgetSetup);
  }
  return null;
}
